import {useMemo} from "react";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {PricesViewType} from "../helpers/prices_view_type";
import {getDistrictDisplayData} from "./get_district_display_data";
import {CURRENT_MONTHS_EARLIER, useDistrictsPriceData} from "./use_districts_price_data";

interface DistrictPriceExtreme {
    name: string;
    avgPriceM2: number;
}

export interface DistrictPriceExtremes {
    min: DistrictPriceExtreme;
    max: DistrictPriceExtreme;
}

export const useDistrictPriceExtremes = (region: IRegionReportPrice, type: PricesViewType): DistrictPriceExtremes | null => {
    // Same queries as useDistrictRows - RTK Query serves both from one cache entry (prefetched on the server).
    const {districtRegions, districtData, referenceDate} = useDistrictsPriceData(region, type);

    const currentMonthDateStart = getFetchQueryDataMonth(CURRENT_MONTHS_EARLIER, referenceDate).date_start;

    return useMemo(() => {
        if (!districtRegions || !districtData) {
            return null;
        }

        const currentMonthData = districtData.filter((item) => item.date === currentMonthDateStart);

        const districts = districtRegions
            .map((districtRegion): DistrictPriceExtreme | null => {
                const slugDistrict = getDistrictDisplayData(districtRegion, region.slug).slug;
                const data = currentMonthData.find((item) => item.slug_district === slugDistrict);

                return data ? {name: data.district, avgPriceM2: data.avg_price_m2} : null;
            })
            .filter((district): district is DistrictPriceExtreme => district !== null);

        if (districts.length === 0) {
            return null;
        }

        return {
            min: districts.reduce((cheapest, district) => (district.avgPriceM2 < cheapest.avgPriceM2 ? district : cheapest)),
            max: districts.reduce((priciest, district) => (district.avgPriceM2 > priciest.avgPriceM2 ? district : priciest))
        };
    }, [districtRegions, districtData, currentMonthDateStart, region.slug]);
};
import {useMemo} from "react";

import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {getFetchQueryDataMonth} from "../helpers/get_fetch_query_data";
import {PricesViewType} from "../helpers/prices_view_type";
import {getDistrictDisplayData} from "./get_district_display_data";
import {CURRENT_MONTHS_EARLIER, useDistrictsPriceData} from "./use_districts_price_data";

interface DistrictPriceExtreme {
    name: string;
    avgPriceM2: number;
}

export interface DistrictPriceExtremes {
    min: DistrictPriceExtreme;
    max: DistrictPriceExtreme;
}

export const useDistrictPriceExtremes = (region: IRegionReportPrice, type: PricesViewType): DistrictPriceExtremes | null => {
    // Same queries as useDistrictRows - RTK Query serves both from one cache entry (prefetched on the server).
    const {districtRegions, districtData, referenceDate} = useDistrictsPriceData(region, type);

    const currentMonthDateStart = getFetchQueryDataMonth(CURRENT_MONTHS_EARLIER, referenceDate).date_start;

    return useMemo(() => {
        if (!districtRegions || !districtData) {
            return null;
        }

        const currentMonthData = districtData.filter((item) => item.date === currentMonthDateStart);

        const districts = districtRegions
            .map((districtRegion): DistrictPriceExtreme | null => {
                const slugDistrict = getDistrictDisplayData(districtRegion, region.slug).slug;
                const data = currentMonthData.find((item) => item.slug_district === slugDistrict);

                return data ? {name: data.district, avgPriceM2: data.avg_price_m2} : null;
            })
            .filter((district): district is DistrictPriceExtreme => district !== null);

        if (districts.length === 0) {
            return null;
        }

        return {
            min: districts.reduce((cheapest, district) => (district.avgPriceM2 < cheapest.avgPriceM2 ? district : cheapest)),
            max: districts.reduce((priciest, district) => (district.avgPriceM2 > priciest.avgPriceM2 ? district : priciest))
        };
    }, [districtRegions, districtData, currentMonthDateStart, region.slug]);
};
